/* eslint-disable jsx-a11y/media-has-caption */
import { AnimatePresence, m } from "motion/react";
import type { FC, MouseEventHandler } from "react";
import VimeoPlayer from "../../../components/VimeoPlayer";
import LazyFramer from "../../../components/general/LazyFramer/LazyFramer";
import { useIsTablet } from "../../../hooks/use-is-screensize";
import Button from "../Button";
import type { VimeoResponse } from "../ImageContainers/ImageContainer";
import ModalPortal from "../ModalPortal";
import * as s from "./VideoModal.module.scss";

type VideoModalProps = {
	isOpen: boolean;
	videoSrc?: string;
	youtubeEmbedId?: string;
	vimeoResponse?: VimeoResponse;
	onClose: MouseEventHandler;
	label?: string;
};

const VideoModal: FC<VideoModalProps> = ({
	isOpen,
	videoSrc,
	youtubeEmbedId,
	vimeoResponse,
	onClose,
	label,
}) => {
	const isTablet = useIsTablet();
	return (
		<ModalPortal show={isOpen} disableFocusLock>
			<LazyFramer>
				<AnimatePresence>
					<m.div
						className={s.videoModal}
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						exit={{ opacity: 0 }}
						transition={{ duration: 0.2 }}
					>
						<Button
							label={label}
							variant="secondary"
							buttonType="standard"
							icon="close"
							className={s.closeButton}
							onClick={onClose}
						/>
						{vimeoResponse?.video_id ? (
							<VimeoPlayer
								videoID={vimeoResponse.video_id}
								playerID={`${vimeoResponse.video_id}_desktop`}
								settings={{
									controls: true,
									loop: false,
									background: false,
									muted: !isTablet,
									autoplay: true,
									responsive: false,
								}}
							/>
						) : videoSrc ? (
							<video width="100%" height="100%" controls autoPlay>
								<source src={videoSrc} type="video/mp4" />
							</video>
						) : (
							<iframe
								src={`https://www.youtube.com/embed/${youtubeEmbedId}?autoplay=1&mute=1`}
								title="Video player"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
								style={{
									position: "absolute",
									top: 0,
									left: 0,
									width: "100%",
									height: "100%",
								}}
							/>
						)}
					</m.div>
				</AnimatePresence>
			</LazyFramer>
		</ModalPortal>
	);
};

export default VideoModal;
